export default __webpack_public_path__ + "static/media/s14.917d2ae5.jpg";